import { render } from "./BuscadorProducto.vue?vue&type=template&id=882ae5be"
import script from "./BuscadorProducto.vue?vue&type=script&lang=js"
export * from "./BuscadorProducto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__